import api from './api.js'
import Vue from 'vue';
const vm = new Vue();

class wsSocket {
    constructor(opt) {
        console.log("opt",opt);
      this.ws = null;
      this.opt = {};
      this.init(opt.wsUrl);
    }
  
    onOpen() {
      this.opt.open && this.opt.open();
      let that = this;
      that.ping();
      this.socketStatus = true;
    }
  
    init(wssUrl) {
      if (wssUrl) {
        this.ws = new WebSocket(wssUrl);
        this.ws.onopen = this.onOpen.bind(this);
        this.ws.onerror = this.onError.bind(this);
        this.ws.onmessage = this.onMessage.bind(this);
        this.ws.onclose = this.onClose.bind(this);
      }
    }
  
    ping() {
      var that = this;
      this.timer = setInterval(function () {
        that.send({ type: 'ping' });
      }, 3000);
    }
  
    send(data) {
      return new Promise((resolve, reject) => {
        try {
          this.ws.send(JSON.stringify(data));
          resolve({ status: true });
        } catch (e) {
          reject({ status: false });
        }
      });
    }
  
    onMessage(res) {
      this.opt.message && this.opt.message(res);
    }
  
    onClose() {
      this.timer && clearInterval(this.timer);
      let that = this
      this.opt.close && this.opt.close();
      setTimeout(that.init(), 2000); // 在一定时间后重连WebSocket
    }
  
    onError(e) {
      this.opt.error && this.opt.error(e);
    }
  
    $on(...args) {
      vm.$on(...args);
    }
  }
  
export function createSocket(wsUrl) {
    console.log("wsUrl",wsUrl);
    return new Promise((resolve, reject) => {
      const ws = new wsSocket({
        wsUrl:api.ws+wsUrl+'/1',
        open() {
          resolve(ws);
        },
        error(e) {
          reject(e);
        },
        message(res) {
          const { type, data = {} } = JSON.parse(res.data);
          vm.$emit(type, data);
        },
        close(e) {
          vm.$emit('close', e);
        },
      });
    });
  }



// WEBPACK FOOTER //
// ./src/router/websocket.js